import { logStartUsage } from 'owa-analytics-start';

// This is a workaround for bug #155070.  It is possible that an extension modifies the DOM so
// that, when React tries to act on the child it is no longer there, which results in a component
// error.  Based on the solution mentioned here:
// https://github.com/facebook/react/issues/11538#issuecomment-417504600
export function patchNode(): void {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function patchRemoveChild(child) {
            // We still want to keep track of how often this is happening, just in case
            if (child.parentNode !== this) {
                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 *	> Argument at index 1 for logStartUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
                logStartUsage('REMOVE_CHILD_ERROR', undefined);
                return child;
            }

            return originalRemoveChild.apply(this, arguments as any) as any;
        };

        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function patchInsertBefore(newNode, referenceNode) {
            // We still want to keep track of how often this is happening, just in case
            if (referenceNode && referenceNode.parentNode !== this) {
                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 *	> Argument at index 1 for logStartUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
                logStartUsage('INSERT_BEFORE_ERROR', undefined);
                return newNode;
            }

            return originalInsertBefore.apply(this, arguments as any) as any;
        };
    }
}
